// extracted by mini-css-extract-plugin
module.exports = {"mapIframeWrapper":"Map_mapIframeWrapper__3vSWS","mapIframe":"Map_mapIframe__P0Er8"};